import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { MenuItemOption, Origin } from "./types";
import { AnchorElement } from "../../../types/commonTypes";
import InfoTooltip from "../../../../common/components/functional/InfoTooltip/InfoTooltip";

export type Props = {
  id: string;
  menuItems: MenuItemOption[];
  anchorEl: AnchorElement;
  onClose: () => void;
  anchorOrigin?: Origin;
  transformOrigin?: Origin;
};

const ActionMenu = ({
  id,
  menuItems,
  anchorEl,
  onClose,
  anchorOrigin = { vertical: "bottom", horizontal: "right" },
  transformOrigin = { vertical: "top", horizontal: "right" },
}: Props) => {
  const open = Boolean(anchorEl);

  return (
    <Menu
      id={`${id}-action-menu`}
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      sx={{ "& .MuiMenu-paper": { borderRadius: "4px" } }}
    >
      {menuItems.map((item, index) => {
        const disabled = !!item.disabled;
        const onClick = disabled
          ? undefined
          : () => {
              onClose();
              item.action(item.key);
            };

        return (
          <MenuItem
            key={index}
            aria-disabled={disabled}
            tabIndex={disabled ? -1 : 0}
            onClick={onClick}
            sx={{
              ...(disabled && {
                opacity: 0.5,
                cursor: "not-allowed",
              }),
            }}
          >
            {item.icon && (
              <ListItemIcon sx={item.iconSx}>{item.icon}</ListItemIcon>
            )}
            <>
              <ListItemText sx={item.textSx} primary={item.label} />
              {item.infoTooltipText && (
                <InfoTooltip
                  style={{ marginLeft: "5px" }}
                  title={item.infoTooltipText}
                />
              )}
            </>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default ActionMenu;
